import {useState} from "react";
import {ILaboratoryShowcase} from "./laboratory-showcase.inteface";
import {ShowcaseWrapperBox} from "./boxes/showcase-wrapper/showcase-wrapper.box";
import {ShowcaseLabelBox} from "./boxes/showcase-label/showcase-label.box";
import {ShowcaseCollapseIndicatorBox} from "./boxes/showcase-collapse-indicator/showcase-collapse-indicator.box";
import {ShowcaseContentWrapperBox} from "./boxes/showcase-content-wrapper/showcase-content-wrapper.box";

export const LaboratoryShowcaseContainerComponent = (showcase: ILaboratoryShowcase) => {
    const [isOpen, setIsOpen] = useState(false)

    const toggleIsOpen = () => {
        setIsOpen(!isOpen)
    }

    return (showcase.showcaseDisabled
        ? null
        : <ShowcaseWrapperBox>
            <input type="checkbox" id={showcase.name} name="showcase-selector" onClick={toggleIsOpen} />
            <ShowcaseLabelBox htmlFor={showcase.name}>{showcase.title}</ShowcaseLabelBox>
            <ShowcaseCollapseIndicatorBox isOpen={isOpen} />
            <ShowcaseContentWrapperBox isOpen={isOpen}>{showcase.renderer}</ShowcaseContentWrapperBox>
        </ShowcaseWrapperBox>)
}